import React from "react";
import { Product } from "../../product";
import { ProductTextRef } from "../../../producttext/ProductText";
import { Customer } from "../../../customers/Customer";
import { Column } from "./Column";
import { ProductTextReferenceViewer } from "../../../producttext/ProductTextReferenceViewer";
import { LanguageCode } from "../../../customers/customerlanguages";
import { ProductListRenderContext } from "../ObjectTable";

export const createProductReferenceColumn = (
  customer: Customer,
  channel: number,
  language: LanguageCode,
  showTextColumns: boolean
): Column => {
  const channelObject = customer.getChannelById(channel);
  const languageObject = customer.getLanguageByCode(language);

  return {
    name: `reference_${channelObject.id}_${languageObject.code}`,
    label: `Reference ${channelObject.display_name} (${languageObject.short_name})`,
    visible: showTextColumns,
    className: "text-column",
    // eslint-disable-next-line react/display-name
    renderCell: (
      product: Product,
      column: Column,
      context: ProductListRenderContext
    ): JSX.Element => {
      const productTextRef = new ProductTextRef(
        product.id,
        channelObject.id,
        languageObject.code
      );
      const { productTexts } = context;
      const productText = productTexts[productTextRef.key];
      return (
        <ProductTextReferenceViewer
          markedForPublish={productTextRef.markedForPublish(
            customer,
            product.channel_language_pairs
          )}
          productText={productText}
        />
      );
    },
    width: 3,
    channelId: channel,
  };
};
